import { Component, OnInit, Input } from '@angular/core';
import { emptyFields, Country, UsersType, TransactionAccountTypes, gstColumnName } from '../utilities/common-file';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { countries } from '../utilities/countries';
import { UntypedFormBuilder } from '@angular/forms';
import { AuthService } from 'src/app/auth/auth.service';
import { CommonService } from 'src/app/utilities/common-service';
import { TransactionService } from '../transactions/transactions.service';
import { NzTableData } from '../utilities/nz-table.adapter';
import { MerchantCategoryCodeSearch } from '../models/merchant-transactions';

@Component({
  selector: 'app-view-transaction',
  templateUrl: './view-transaction.component.html',
})
export class ViewTransactionsComponent implements OnInit {
  @Input() value: any;
  @Input() id: any;
  @Input() reportType: any;
  merchantDetails: any;
  selectedTransaction: any;
  private selectedTab = 0;
  selectedIndex = 0;
  emptyField = emptyFields;
  country = Country;
  countries = countries;
  userType = UsersType;
  transactionAccountTypes = TransactionAccountTypes;
  loadingForRefund = false;
  loginUserType = '';
  showFields = false;
  isLoading = true;
  gst:any = localStorage.getItem('gst');
  hst:any = localStorage.getItem('hst');
  gstColumnName = gstColumnName;
  columnName :any;
  businessModels:any;
  mccOptions: any[] = [];
  matchedMccCode: string = '';
   private mccData: NzTableData<MerchantCategoryCodeSearch, any> = new NzTableData
    <MerchantCategoryCodeSearch, any>(new MerchantCategoryCodeSearch(), 'name');
  constructor(private drawerRef: NzDrawerRef,
    private fb: UntypedFormBuilder, private authService: AuthService, private commonService: CommonService, private transactionService: TransactionService) {
  }
  ngOnInit() {
    this.hst = (this.hst === "true");
    this.gst = (this.gst === "true");
    if(this.gst && this.hst){
      this.columnName = this.gstColumnName.hst;
      }
      if(this.gst && !this.hst){
      this.columnName = this.gstColumnName.gst;
      }
    this.selectedTab -= 1;
    this.selectedTransaction = this.value;
    this.loginUserType = this.authService.getRole();
    this.showFields = this.authService.showOptionsBasedOnUserType();

    if (this.value) {
      this.selectedTransaction = this.value;
      this.isLoading = false;

    } else {
      this.isLoading = true;
      this.viewMerchantTransaction();
    }
 this.transactionService.getMerchantBusinessModelWithLimit().subscribe((response: any) => {
  const data = response.data.merchantBusinessModel;
  this.businessModels = data;

  // Match selected merchant's businessModelId
  if (this.selectedTransaction.merchant.businessModelId) {
    this.selectedTransaction.businessModel = data.find(
      (model: any) => model.id === this.selectedTransaction.merchant.businessModelId
    ) || null;
  }
});

  }
  // To View Transaction details
  viewMerchantTransaction() {
    const value = { id: this.id, merchantId: this.authService.getMerchantId() }
    this.transactionService.viewMerchantTransactionBasedOnID(value).subscribe((response: any) => {
      this.selectedTransaction = response.data.transactions[0];
      this.fetchMccData();
      this.isLoading = false;
    }, () => {
    });
  }
  tab(index: number) {
    this.selectedTab = index;
  }
  getCurrency(currency) {
    const index = this.countries.findIndex(M => M.currency_code === currency);
    if (index !== -1) {
      return this.countries[index].currency_symbol;
    }
  }
  // Get Frequency Status
  getFrequencyForSettlementStatus(status) {
    return this.commonService.getSettlementFrequencyStatus(status);
  }
  getKycStatus(status) {
    return this.commonService.getKycStatus(status);
  }
  getTier(tier) {
    return this.commonService.getTier(tier);
  }
  getTransactionType(mode) {
    return this.commonService.getTransactionAccountType(mode);
  }
  // tslint:disable-next-line: indent
  getColorForTransactionType(mode) {
    return this.commonService.getColorForTransactionAccountType(mode);
  }
  getUserType(role) {
    return this.commonService.getUserType(role);
  }
  close() {
    this.drawerRef.close();
  }
   fetchMccData(): void {
      this.mccData.pageIndex = null;
      this.mccData.pageSize = null;
      this.transactionService.getMerchantCategoryWithLimit(this.mccData).subscribe((response: any) => {
        if (response.data && response.data.merchantCategoryCodes) {
          this.mccOptions = response.data.merchantCategoryCodes;
          this.matchMccCode();
        } else {
          this.mccOptions = [];
        }
      }, (err) => {
        console.error('', err);
        this.mccOptions = [];
      });
    }
   matchMccCode(): void {
      if (this.selectedTransaction && this.selectedTransaction.merchant.mcc) {
        const mccItem = this.mccOptions.find(item => item.id === this.selectedTransaction.merchant.mcc);
        if (mccItem) {
          this.matchedMccCode = mccItem.code;
        } else {
          this.matchedMccCode = 'NA';
        }
      }
    }
}
